import {lazy, useLayoutEffect, useState} from "react";
import Routing from "@/components/routing.tsx";
import FullscreenLoading from "@/components/fullscreenLoading.tsx";
import type {User} from "@/api/model";
import {useGetMe} from "@/api/user/user.ts";
import {setUserDispatch} from "@/lib/customApiInstance.ts";
import {useUpdateSW} from "@/hooks/useUpdateSW.ts";

const Login = lazy(() => import("@/pages/login.tsx"));
const getMeOptions = {query: {retry: 1}}

function App() {
    useUpdateSW()
    const [user, setUser] = useState<User>()
    const {data, isLoading, isFetched} = useGetMe(getMeOptions);
    useLayoutEffect(() => {
        setUserDispatch.current = setUser;
    }, []);
    useLayoutEffect(() => {
        if (data) {
            setUser(data)
        }
    }, [data]);
    if (isLoading && !isFetched) {
        return <FullscreenLoading/>
    }
    if (!user) {
        return (
            <>
                <Login setUser={setUser}/>
                {isLoading && <FullscreenLoading withBg/>}
            </>
        )
    }
    return (
        <>
            <Routing user={user}/>
            {isLoading && <FullscreenLoading withBg/>}

        </>
    )
}

export default App;
